import { applyMiddleware, compose, createStore } from 'redux';
import { Map } from 'immutable';
import { reducer, regHandlers } from './reducer';
import { regSaga, runSaga, sagaMiddleware } from './saga';
import { regRoute } from './router';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      name: 'System Platform Consoles',
    })
  : compose;

const store = createStore(
  reducer,
  Map(),
  composeEnhancers(applyMiddleware(sagaMiddleware)),
);

const action = (type, payload) => ({ type, payload });
const dispatch = (type, payload) =>
  typeof type !== 'string'
    ? store.dispatch(type)
    : store.dispatch({ type, payload });
const dispatcher = type => payload => store.dispatch({ type, payload });

export {
  action,
  dispatch,
  dispatcher,
  reducer,
  regHandlers,
  regRoute,
  regSaga,
  runSaga,
  store,
};
